var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessengerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    clipPath: "url(#clip0_4013_291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 0C8.73033 0 0 8.26978 0 18.4707C0 24.2435 2.79659 29.3932 7.17578 32.7798V40L13.7426 36.1214C15.5615 36.6544 17.4967 36.9414 19.5 36.9414C30.2697 36.9414 39 28.6716 39 18.4707C39 8.26978 30.2697 0 19.5 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.07959 24.3583L17.4085 12.9561L22.4007 17.9459L31.9204 12.9561L21.1226 24.9528L16.3668 18.9545L7.07959 24.3583Z",
    fill: "#3364D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4013_291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerIcon);
export default __webpack_public_path__ + "static/media/messenger-icon.ca85e5691e4722e2ee219d2bcb224690.svg";
export { ForwardRef as ReactComponent };